// Dexie (IndexedDB) — 離線 outbox 與本地快取
// see architecture.md#L580

import Dexie from 'dexie';

export const db = new Dexie('smartipos');

db.version(1).stores({
  // id 為 server-assigned uuid，若尚未同步則為 local
  menu_items: 'id, category_id, tenant_id, is_available',
  menu_categories: 'id, tenant_id, sort_order',
  orders_outbox: '++local_id, idempotency_key, created_at, retry_count',
  orders_cache: 'id, tenant_id, status, created_at',
  drafts: 'id, target_date, status',
});

// Phase 2c (2026-04-23)：workflow cache — 離線可渲染訂單頁
// key 為 tenant_id；value 包含 workflow metadata + states + transitions + version
db.version(2).stores({
  menu_items: 'id, category_id, tenant_id, is_available',
  menu_categories: 'id, tenant_id, sort_order',
  orders_outbox: '++local_id, idempotency_key, created_at, retry_count',
  orders_cache: 'id, tenant_id, status, created_at',
  drafts: 'id, target_date, status',
  workflow_cache: 'id, version, cachedAt',
});

export async function enqueueOutbox({ endpoint, payload, idempotencyKey }) {
  return db.orders_outbox.add({
    endpoint,
    payload,
    idempotency_key: idempotencyKey,
    created_at: Date.now(),
    retry_count: 0,
    last_attempt: null,
    last_error: null,
  });
}

export async function getPendingOutbox() {
  return db.orders_outbox.where('retry_count').below(5).toArray();
}

export async function removeFromOutbox(localId) {
  return db.orders_outbox.delete(localId);
}

export async function markOutboxRetry(localId, error) {
  const item = await db.orders_outbox.get(localId);
  if (!item) return;
  return db.orders_outbox.update(localId, {
    retry_count: item.retry_count + 1,
    last_attempt: Date.now(),
    last_error: error,
  });
}
